import { Box, IconButton, Menu, MenuItem } from "@mui/material";
import { useState, useContext, useMemo } from "react";
import PermIdentityIcon from "@mui/icons-material/PermIdentity";

import { DemandWalkEditsContext } from "../../../contexts/demand_walk_edits";
import { useForceUserEditConclude } from "../../modals/force_user_edit_conclude";
import { customLogout } from "../../../utils/auth";
import {
  ClientFeatureFlags,
  convertToClientFeatures,
} from "../../../types/feature_flags";
import { useCustomer } from "../../../contexts/app/provider";
import { useGuardedNavigation } from "../../../hooks/use_guarded_navigation";

export const ProfileMenu = () => {
  const { editMode } = useContext(DemandWalkEditsContext);
  const handleLogout = async () => {
    await customLogout();
  };
  const { navigateWithGuards } = useGuardedNavigation();
  const { openForceUserEditModal } = useForceUserEditConclude();

  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const handleMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
    setIsMenuOpen(true);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    setIsMenuOpen(false);
  };
  const { customerSettings } = useCustomer();

  const features: ClientFeatureFlags = useMemo(
    () => convertToClientFeatures(customerSettings?.features),
    [customerSettings]
  );

  return (
    <Box>
      <IconButton onClick={handleMenuOpen}>
        <PermIdentityIcon sx={{ width: "25px", height: "25px" }} />
      </IconButton>
      <Menu
        anchorEl={anchorEl}
        open={isMenuOpen}
        onClose={handleMenuClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <MenuItem
          onClick={() => {
            if (editMode) {
              openForceUserEditModal();
              return;
            }
            navigateWithGuards("/profile");
            handleMenuClose();
          }}
        >
          Profile
        </MenuItem>
        {features?.MyTeam && (
          <MenuItem
            onClick={() => {
              navigateWithGuards("/my-team");
              handleMenuClose();
            }}
          >
            My Team
          </MenuItem>
        )}
        <MenuItem
          onClick={() => {
            handleLogout();
            handleMenuClose();
          }}
        >
          Logout
        </MenuItem>
      </Menu>
    </Box>
  );
};
